export default __webpack_public_path__ + "static/media/background.595d7158.jpg";